import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import TheBasesYCondicionesLOLLAPALLOOZA from './TheBasesYCondicionesLOLLAPALLOOZA.vue'
import TheBasesYCondicionesJPEGMAFIA from './TheBasesYCondicionesJPEGMAFIA.vue'

import TheBasesYCondicionesJeepNature from './TheBasesYCondicionesJeepNature.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheBasesYCondiciones',
  props: {
    id: null,
    name: null
  },
  setup(__props: any) {

const props = __props as {
  id?: number
  name?: string
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (['JPEGMAFIA'].includes(props.name?.toUpperCase()) || [114].includes(props.id))
      ? (_openBlock(), _createBlock(TheBasesYCondicionesJPEGMAFIA, { key: 0 }))
      : _createCommentVNode("", true),
    (['LOLLAPALOOZA'].includes(props.name?.toUpperCase()) || [108].includes(props.id))
      ? (_openBlock(), _createBlock(TheBasesYCondicionesLOLLAPALLOOZA, { key: 1 }))
      : _createCommentVNode("", true),
    (['JEEP NATURE'].includes(props.name?.toUpperCase()) || [116].includes(props.id))
      ? (_openBlock(), _createBlock(TheBasesYCondicionesJeepNature, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})